"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _a, _b;
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var client_lib_js_player_framework_utils_1 = require("@sky-uk-ott/client-lib-js-player-framework-utils");
var KEY_CODE_MAP = (_a = {},
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.UP] = [38],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.DOWN] = [40],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.LEFT] = [37],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.RIGHT] = [39],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.ENTER] = [13],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.BACK] = [8, 27],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.FF] = [228],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.RW] = [227],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.PLAY] = [179],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.PAUSE] = [179],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.STOP] = [178],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[1]] = [49],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[2]] = [50],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[3]] = [51],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[4]] = [52],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[5]] = [53],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[6]] = [54],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[7]] = [55],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[8]] = [56],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[9]] = [57],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[0]] = [48],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_9] = [32],
    _a);
var KEY_MAP = (_b = {},
    _b[client_lib_js_player_framework_utils_1.CTV_KEY.RED] = ['ColorF0Red'],
    _b[client_lib_js_player_framework_utils_1.CTV_KEY.GREEN] = ['ColorF1Green'],
    _b[client_lib_js_player_framework_utils_1.CTV_KEY.YELLOW] = ['ColorF2Yellow'],
    _b[client_lib_js_player_framework_utils_1.CTV_KEY.BLUE] = ['ColorF3Blue'],
    _b[client_lib_js_player_framework_utils_1.CTV_KEY.INFO] = ['Info'],
    _b[client_lib_js_player_framework_utils_1.CTV_KEY.SUBTITLES] = ['ClosedCaptionToggle'],
    _b[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_9] = ['ColorF0Red'],
    _b);
var PREVENT_DEFAULT = new Set([
    27,
    38,
    40,
    37,
    39,
    13,
    8,
    33,
    34,
    32,
    80,
    83,
    82,
    71,
    66,
    89,
    73,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    48,
    228,
    227,
    179,
    178,
]);
var PREVENT_DEFAULT_KEY = new Set([
    'ClosedCaptionToggle',
    'Info',
    'ColorF0Red',
    'ColorF1Green',
    'ColorF2Yellow',
    'ColorF3Blue',
]);
var AndroidInput = (function (_super) {
    __extends(AndroidInput, _super);
    function AndroidInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.keyCodeMap = KEY_CODE_MAP;
        _this.keyMap = KEY_MAP;
        _this.preventDefault = PREVENT_DEFAULT;
        _this.preventDefaultKey = PREVENT_DEFAULT_KEY;
        return _this;
    }
    AndroidInput.prototype.handleKeyEvent = function (keyEventObservable, event) {
        if (event.keyCode > 0) {
            return _super.prototype.handleKeyEvent.call(this, keyEventObservable, event);
        }
        if (this.preventDefaultKey.has(event.key)) {
            if (event.preventDefault) {
                event.preventDefault();
            }
        }
        var ctvKeys = client_lib_js_player_framework_utils_1.lookupCTVKeysForKeyCode(this.keyMap, event.key);
        var key = ctvKeys[0], secondaryKey = ctvKeys[1], otherKeys = ctvKeys.slice(2);
        var extendedEvent = {
            key: key,
            keyCode: event.keyCode,
        };
        if (ctvKeys.length > 1) {
            extendedEvent.secondaryKey = secondaryKey;
            extendedEvent.otherKeys = [secondaryKey].concat(otherKeys);
        }
        keyEventObservable.notifyObservers(extendedEvent);
    };
    return AndroidInput;
}(client_lib_js_player_addons_common_player_1.Input));
exports.AndroidInput = AndroidInput;
